import axios from "axios";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export default {
    namespaced: true,
    state: {
        shopify_store: null,
        shopify_access_code: null,
    },
    getters: {
      apiUrl(state) {
        //return "http://127.0.0.1:5001/arthur-5a26e/us-central1";
        return process.env.VUE_APP_FUNCTIONS_URL
      } 
    },
    mutations: {
      apiInitiated(state, body){
        state.shopify_access_code = body.access_code;
        state.shopify_store = body.shop;
      }
    },
    actions: {
        apiGet(context, body) {
          var options = getOptions(context, body.path, 'GET', body.headers, undefined, {});
          return executeRequest(options);
        },
        apiPost(context, body) {
          var options = getOptions(context, body.path, 'POST', body.headers, body.body, {});
          return executeRequest(options)
        },
        async apiGetWithToken(context, body) {
          var options = await getTokenOptions(context, body.path, 'GET', body.headers, undefined, {});
          return executeRequest(options)
        },
        async apiPostWithToken(context, body) {
          var options = await getTokenOptions(context, body.path, 'POST', body.headers, body.body, {});
          return executeRequest(options)
        },

        initiateApi({commit}, body){
          commit("apiInitiated", body)
        }
    }
};

function executeRequest(options) {
  return new Promise((resolve, reject) => {
    axios(options)
      .then(data =>
        resolve(data)
      ).catch(error =>
        reject(error)
      )
  })
}

var getOptions = function (context, path, method, headers, data, params) {
  var options = {
    url: context.getters.apiUrl + path,
    method: method,
    headers: {},
  };
  if (headers) {
    options.headers = Object.assign({}, options.headers, headers);
  }
  if (data) {
    options.data = data;
  }

  if (params) {
    options.params = params;
  }

  return options;
}

var getTokenOptions = async function (context, path, method, headers, body, params) {
  const user = firebase.auth().currentUser;
  if (!user || !user.uid) {
    throw new Error("Sign in before requesting store data.");
  }
  const idToken = await user.getIdToken();
  if (firebase.auth().currentUser !== user) {
    throw new Error("The store session changed. Please retry the request.");
  }

  // The Firebase session remains available without the legacy Shopify cookie.
  const newparams = { ...params, shopName: user.uid };
  if (context.state.shopify_store === user.uid && context.state.shopify_access_code) {
    newparams.access_token = context.state.shopify_access_code;
  }
  const requestHeaders = { ...headers, Authorization: `Bearer ${idToken}` };
  return getOptions(context, path, method, requestHeaders, body, newparams);
};
